import styled from 'styled-components';

export const BoxMessageStyle = styled.div`
	position: relative;

	.container-text {
		padding-right: 150px;
	}

	&.amInterested {
		.imageCar {
			width: 180px;
			display: block;
			position: absolute;
			bottom: -20px;
			right: 0;
			opacity: 0.4;
		}
	}

	.imageCar {
		display: none;
	}

	.box-message {
		border-radius: 5px;
		padding: 25px
			25px
			50px
			25px;
		background-color: #ffffff;
		margin-bottom: 30px;
		box-shadow: 0
			3px
			4px
			rgba(
				0,
				0,
				0,
				0.2
			);
		position: relative;
		font-size: 0.9em;

		img {
			width: auto;
			margin-bottom: 20px;
		}

		.pointer {
			padding: 10px;
		}

		.btn-agreed {
			font-family: Poppins-Medium,
				Heltica,
				Arial,
				sans-serif;
			position: absolute;
			bottom: 0;
			right: 0;
			cursor: pointer;
			padding: 15px;
			color: #c5c6d0;
			font-size: 1.4em;

			&:hover {
				color: #2b2932;
			}
		}

		.btn-close {
			position: absolute;
			top: 0;
			right: 0;
			cursor: pointer;
			padding: 15px;

			.active-path {
				fill: #c5c6d0;
			}

			&:hover {
				.active-path {
					fill: #2b2932;
				}
			}
		}

		h3 {
			font-family: Poppins-Medium,
				Heltica,
				Arial,
				sans-serif;
			font-size: 1.4em;

			&:after {
				content: '';
				margin: 5px
					0;
				display: block;
				width: 80px;
				height: 2px;
				background-color: #ff003b;
			}
		}

		p {
			font-family: Poppins,
				Heltica,
				Arial,
				sans-serif;
			margin-top: 15px;
			font-size: 1.6em;
			line-height: 1.5em;
		}

		.btn.btn-gearbox {
			font-family: Poppins-Medium,
				Heltica,
				Arial,
				sans-serif;
			width: 100%;
			padding: 10px
				0;
			font-size: 1.4em;
			text-align: center;
			background-color: #ff003d;
			border-color: #ff003d;
			color: #ffffff;
		}

		.content-logo
			img {
			width: 65px;
		}
	}
`;
